import { copyNodePropsFromDoc } from "@/models/nodes/copyNodePropsFromDoc";

import type { SingleSuggestion, SuggestionNodeType } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";
import type { CopyNodePropsOptions } from "@/models/nodes/copyNodePropsFromDoc";
import type { NodeJson } from "@corca/data";

type InjectOptions<T extends SuggestionNodeType> = CopyNodePropsOptions & {
  extend?: (injectedNodesJson: NodeJson[]) => Partial<SingleSuggestion<T>>;
};

export function injectNodePropsToSuggestion<T extends SuggestionNodeType>(
  doc: DocumentModel,
  suggestion: SingleSuggestion<T>,
  { extend = () => ({}), ...copyOptions }: InjectOptions<T> = {},
): SingleSuggestion<T> {
  const { item } = suggestion;

  if (!item.nodesJson) {
    return suggestion;
  }

  const injectedNodesJson = item.nodesJson.map((nodeJson) =>
    copyNodePropsFromDoc(doc, nodeJson, copyOptions),
  );

  return {
    ...suggestion,
    item: { ...item, nodesJson: injectedNodesJson },
    ...extend(injectedNodesJson),
  };
}
